import React, { useState, useEffect } from "react";
import Portal from "../Portal/Portal";
import { ReactComponent as LoadingSvg } from "../../assets/icons/NarratorTab/Dual Ring-1s-32px.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/Common/question-feedback-icon.svg";
import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";
import ILessonMetaRequest from "../../models/ILessonMetaRequest";
import { PERCENTAGE_THRESHOLDS, WARNING_COLORS, BYTES_IN_MB, DEFAULT_MAX_LESSON_SIZE } from "./constants";
function calculatePercentage(val1: number, val2: number) {
  return (val2 * 100) / val1;
}

const LessonSize = ({
  lessonSizeInBytes,
  maxLessonSizeMB = DEFAULT_MAX_LESSON_SIZE,
}: Pick<ILessonMetaRequest, "lessonSizeInBytes" | "maxLessonSizeMB">) => {
  const [lessonMB, setLessonMB] = useState(0);
  const [showSizeWarning, setShowSizeWarning] = useState(false);
  const [hasLessonSizeWarningAppeared, setHasLessonSizeWarningAppeared] = useState(false);

  const percentage = calculatePercentage(maxLessonSizeMB, lessonMB);
  const OVER_LIMIT = lessonMB > maxLessonSizeMB;

  useEffect(() => {
    const res = lessonSizeInBytes / BYTES_IN_MB;
    const largeThreshold = (PERCENTAGE_THRESHOLDS.large / 100) * maxLessonSizeMB;
    if (res > largeThreshold) {
      setShowSizeWarning(true);
    }
    setLessonMB(res);
  }, [lessonSizeInBytes]);

  function barColor(MB: number) {
    const percentage = calculatePercentage(maxLessonSizeMB, MB);

    if (percentage >= PERCENTAGE_THRESHOLDS.maximum) {
      return WARNING_COLORS.maximum;
    }

    if (percentage > PERCENTAGE_THRESHOLDS.warning) {
      return WARNING_COLORS.warning;
    }

    if (percentage > PERCENTAGE_THRESHOLDS.large) {
      return WARNING_COLORS.large;
    }

    return WARNING_COLORS.normal;
  }
  function lessonSizeDataTip(MB: number) {
    const percentage = calculatePercentage(maxLessonSizeMB, MB);
    let output = "LSize";
    if (percentage >= PERCENTAGE_THRESHOLDS.maximum) {
      output += "Red"; // red
    } else if (percentage > PERCENTAGE_THRESHOLDS.warning) {
      output += "Orange"; // orange
    } else if (percentage > PERCENTAGE_THRESHOLDS.large) {
      output += "Yellow"; // yellow
    }
    return output;
  }

  function handleCloseWarningModal() {
    // if(!OVER_LIMIT) {
    setShowSizeWarning(false);
    setHasLessonSizeWarningAppeared(true);
    // }
  }
  return (
    <div className="lesson-size-tab">
      <span style={{ whiteSpace: "nowrap" }}>
        {percentage > PERCENTAGE_THRESHOLDS.large ? <InfoIcon title="" data-tooltip-id={"lessonSize"} /> : null}
        <Tooltip id="lessonSize" content={lessonSizeDataTip(lessonMB)} />
        Lesson Size:
        {lessonMB ? lessonMB.toFixed(0) : <LoadingSvg style={{ display: "inline", height: "80%", width: "8%" }} />}
        MB/{maxLessonSizeMB}MB
      </span>

      <div className="lesson-size-progress" style={{ width: `${percentage}%`, background: barColor(lessonMB) }}></div>
      {showSizeWarning && !hasLessonSizeWarningAppeared && (
        <Portal path={"delete-confirm-container"}>
          <div className="delete-confirm-modal">
            <div className="delete-confirm-header">
              <p>Lesson Size</p>
            </div>
            <div className="delete-confirm-text" style={{ display: "flex", flexDirection: "column" }}>
              <h4 style={{ alignSelf: "center" }}>
                <strong>Warning!</strong>
              </h4>
              {!OVER_LIMIT ? (
                <p>
                  The lesson size is{" "}
                  <strong>
                    {lessonMB ? lessonMB.toFixed(0) : <LoadingSvg style={{ display: "inline", height: "35%" }} />}
                    MB
                  </strong>
                  , the maximum size allowed is <strong>{maxLessonSizeMB}MB</strong>. If the lesson reaches{" "}
                  <strong>{maxLessonSizeMB}MB</strong> you will need to reduce the lesson size.
                </p>
              ) : (
                <h6>Reduce Lesson Size</h6>
              )}
            </div>
            <div className="delete-confirm-buttons-container">
              <button className="main-modal-button" onClick={handleCloseWarningModal}>
                Close
              </button>
            </div>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default LessonSize;
